import { REFERRALS } from 'common/constants/copy';

type ProcessKeys = keyof typeof REFERRALS.PROCESS;
const processKeys: ProcessKeys[] = ['SHARE_STEP', 'DISCOUNT_STEP', 'EARNINGS_STEP'];

export const referralsProcessSteps = processKeys.map((key) => {
  const step = REFERRALS.PROCESS[key];
  return {
    title: step.TITLE,
    description: step.DESCRIPTION,
    descriptionLine2: 'DESCRIPTION_LINE_2' in step ? step.DESCRIPTION_LINE_2 : undefined,
    disclaimer: 'DISCLAIMER' in step ? step.DISCLAIMER : undefined,
  };
});

export const promoSectionLightBg = '#FAF0E6';
